 <template lang="pug">
  v-dialog(v-model='dialog' scrollable persistent content-class="flex xs12 sm7 md6")
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline {{ formTitle }}
      v-divider
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-row(dense)
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense, outlined, v-model='form.codLinea', :readonly='read', id='codLinea', label='Código')
                  v-col(cols='12' sm='12' md='6')
                    v-text-field(dense, outlined, v-model='form.descripcion', :readonly='read', id='descripcionLinea', label='Descripcion', v-uppercase)
                  v-col(cols='12' sm='12' md='12')
                    //Hijo Sublinea
                    SubLinea(p='activar' :read='readaux' :prod='form.subLinea')
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
        v-btn(v-if='!read' color='success' small dark @click='save')
          v-icon mdi-content-save
          | Guardar
</template>

<script>
import Api from '@/services/methods'
import SubLinea from '../SubLinea'

export default {
  props: ['dialog', 'editedIndex', 'FormPadre', 'read'],
  data: () => ({
    readaux: false,
    linea: [],
    search: '',
    permisosRuta: {},
    form: {
      codLinea: '',
      descripcion: '',
      subLinea: []
    },
    defaultItem: {
      codLinea: '',
      descripcion: '',
      subLinea: []
    }
  }),
  components: {
    SubLinea
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Categoria'
        : this.read
          ? 'Informacion del Categoria'
          : 'Modificar Categoria'
    }
  },
  watch: {
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
      }
    },
    read (val) {
      this.readaux = val
    }
  },

  created () {
    this.initialize()
    /* this.permisosRuta = this.$store.state.empresa[0].permisos.find(
                         permiso => permiso.ruta == "Linea"
     ); */
  },

  methods: {
    initialize () {
    },

    close () {
      setTimeout(() => {
        this.form = Object.assign({}, this.defaultItem)
      }, 300)
      this.$emit('close')
    },

    validarCampos () {
      if (this.form.descripcion === '' || this.form.codLinea === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene los campos para continuar'
        })
        return true
      } /* else if (this.form.subLinea.length <= 0) {
        this.$swal({
          icon: 'error',
          title: 'No existen SubCategoria cargadas',
          text: 'Porfavor cargue SubCategoria para seguir con el proceso'
        })
        return true
      } */
      return false
    },
    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('linea', this.form)
            .then(response => {
              this.$emit('edited')
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al modificar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        } else {
          Api.post('linea', this.form)
            .then(response => {
              this.$emit('save')
              this.form._id = response.data._id
              this.$swal({
                icon: 'success',
                title: 'Inclusion exitosa',
                text: 'Todos los datos han sido guardados'
              })
              this.close()
            })
            .catch(error => {
              if (error.response) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Por favor, verifique los datos e intente de nuevo'
                })
              } else if (error.request) {
                this.$swal({
                  icon: 'error',
                  title: 'Error de red',
                  text: 'Por favor verique su conexion de internet'
                })
              } else {
                console.log('Error', error.message);
              }
            })
        }
        this.close()
      }
    }
  }
}
</script>
